import { useId } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { ROLE_LABELS } from '@blimo/shared';
import { Checkbox } from '@blimo/ui';

/**
 * Multi-select of roles as a checkbox group (form value: string[]).
 * @param {{ name?: string, roles: Array<{ name: string, permissions?: string[] }>, hiddenCount?: number }} props
 */
export function RoleCheckboxes({ name = 'roles', roles, hiddenCount = 0 }) {
  const { control } = useFormContext();
  const id = useId();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const value = field.value ?? [];
        const toggle = (role, checked) => field.onChange(checked ? [...value, role] : value.filter((r) => r !== role));
        return (
          <fieldset className="flex flex-col gap-2" aria-invalid={Boolean(fieldState.error)} aria-describedby={fieldState.error ? `${id}-error` : undefined}>
            <legend className="mb-1 text-sm font-medium">Rollen</legend>
            {roles.length === 0 && <p className="text-sm text-muted-foreground">Rollen werden geladen …</p>}
            {roles.map((role) => (
              <label key={role.name} className="flex items-start gap-2 text-sm">
                <Checkbox className="mt-0.5" checked={value.includes(role.name)} onChange={(e) => toggle(role.name, e.target.checked)} onBlur={field.onBlur} />
                <span title={role.permissions ? `${role.permissions.length} Rechte` : undefined}>{ROLE_LABELS[role.name] ?? role.name}</span>
              </label>
            ))}
            {hiddenCount > 0 && (
              <p className="text-xs text-muted-foreground">Privilegierte Rollen (Super-Admin, Administrator) kann nur vergeben, wer Rollen verwalten darf.</p>
            )}
            {fieldState.error && (
              <p id={`${id}-error`} className="text-xs font-medium text-destructive">
                {fieldState.error.message}
              </p>
            )}
          </fieldset>
        );
      }}
    />
  );
}
